export default "__VITE_ASSET__78d71c4b__"